var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    {
      staticClass: "products-table",
      style: { width: "100%" },
      attrs: { id: "products-table", tag: "table", x: "", y: false },
    },
    [
      _c("thead", { staticClass: "head" }, [
        _c(
          "tr",
          [
            _c(
              "app-products-table-info-head",
              {
                attrs: {
                  name: "qty",
                  "stored-widths": _vm.storedWidths,
                  "minimum-widths": _vm.minimumWidths,
                },
              },
              [_vm._v(" " + _vm._s(_vm.$ct("sales-row.Qty1")) + " ")]
            ),
            _vm.useQty2
              ? _c(
                  "app-products-table-info-head",
                  {
                    attrs: {
                      name: "qty2",
                      "stored-widths": _vm.storedWidths,
                      "minimum-widths": _vm.minimumWidths,
                    },
                  },
                  [_vm._v(" qty2Label ")]
                )
              : _vm._e(),
            !_vm.hideUnits
              ? _c(
                  "app-products-table-info-head",
                  {
                    attrs: {
                      name: "unit",
                      "stored-widths": _vm.storedWidths,
                      "minimum-widths": _vm.minimumWidths,
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.unitLabel) + " ")]
                )
              : _vm._e(),
            _c(
              "app-products-table-info-head",
              {
                attrs: {
                  name: "sku",
                  "stored-widths": _vm.storedWidths,
                  "minimum-widths": _vm.minimumWidths,
                },
              },
              [_vm._v(" " + _vm._s(_vm.$ct("sales-row.Sku")) + " ")]
            ),
            _c(
              "app-products-table-info-head",
              {
                attrs: {
                  name: "description",
                  "stored-widths": _vm.storedWidths,
                  "minimum-widths": _vm.minimumWidths,
                },
              },
              [_vm._v(" " + _vm._s(_vm.$ct("sales-row.Name")) + " ")]
            ),
            _c(
              "app-products-table-info-head",
              {
                attrs: {
                  "after-description": "",
                  "align-right": "",
                  name: "unit-price",
                  "stored-widths": _vm.storedWidths,
                  "minimum-widths": _vm.minimumWidths,
                },
              },
              [_vm._v(" " + _vm._s(_vm.$ct("sales-row.UnitPrice")) + " ")]
            ),
            _c(
              "app-products-table-info-head",
              {
                attrs: {
                  "after-description": "",
                  "align-right": "",
                  name: "discount",
                  "stored-widths": _vm.storedWidths,
                  "minimum-widths": _vm.minimumWidths,
                },
              },
              [_vm._v(" " + _vm._s(_vm.$ct("sales-row.Discount")) + " ")]
            ),
            _c(
              "app-products-table-info-head",
              {
                attrs: {
                  "after-description": "",
                  "align-right": "",
                  name: "vat",
                  "stored-widths": _vm.storedWidths,
                  "minimum-widths": _vm.minimumWidths,
                },
              },
              [_vm._v(" " + _vm._s(_vm.$ct("sales-row.Vat")) + " ")]
            ),
            _c(
              "app-products-table-info-head",
              {
                attrs: {
                  "after-description": "",
                  "align-right": "",
                  name: "netto",
                  "stored-widths": _vm.storedWidths,
                  "minimum-widths": _vm.minimumWidths,
                },
              },
              [_vm._v(" " + _vm._s(_vm.$ct("sales-row.NettoPrice")) + " ")]
            ),
            _c(
              "app-products-table-info-head",
              {
                attrs: {
                  "after-description": "",
                  "align-right": "",
                  name: "bruto",
                  "stored-widths": _vm.storedWidths,
                  "minimum-widths": _vm.minimumWidths,
                },
              },
              [_vm._v(" " + _vm._s(_vm.$ct("sales-row.BrutoPrice")) + " ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "w-scroll-view",
        { staticClass: "body" },
        _vm._l(_vm.items, function (row, i) {
          return _c("app-row", {
            key: i,
            attrs: {
              "row-index": i,
              row: row,
              "is-selected": false,
              widths: _vm.storedWidths,
              sale: _vm.sale,
              "show-qty2": _vm.useQty2,
              "currency-rate":
                _vm.sale.CurrencyRate !== 0 ? _vm.sale.CurrencyRate : 1,
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }